const { z } = require('zod');


const phonePattern = /^\d*$/;

export const emergencyContactSchema = z.object({
  id: z.string().nullish(),
  name: z
    .string({ message: "Name is Required" })
    .min(1, { message: "Name is Required" })
    .max(50, { message: "Must be 50 or fewer characters long" }),
  relationship: z
    .string({ message: "Relationship is Required" })
    .min(1, { message: "Relationship is Required" })
    .max(20, { message: "Must be 20 or fewer characters long" }),
  dialCode: z.any(),
  phone: z.string({ message: "Phone is Required" }).regex(phonePattern, {
    message: "Phone must be only numbers. (e.g., 23456789012)",
  }),
});

export const profileContact = 
  z.object({
    address1: z
      .string({ message: "Address 1 is Required" })
      .min(1, { message: "Address 1 is Required" })
      .max(50, { message: "Must be 50 or fewer characters long" }),
    address2: z.string().nullish(),
    city: z
      .string({ message: "City is Required" })
      .min(1, { message: "City is Required" })
      .max(20, { message: "Must be 20 or fewer characters long" }),
    state: z
      .string({ message: "State is Required" })
      .min(5, { message: "State is Required" })
      .max(10, { message: "Must be 10 or fewer characters long" }),
    zip: z
      .string({ message: "Zip is Required" })
      .min(1, { message: "Zip is Required" })
      .max(20, { message: "Must be 20 or fewer characters long" }),
    primaryDialCode: z.any(),
    primaryPhone: z
      .string()
      .min(1, { message: "Phone is Required" })
      .regex(phonePattern, {
        message: "Phone must be only numbers. (e.g., 23456789012)",
      }),
    secondaryDialCode: z.any(),
    secondaryPhone: z
      .union([
        z.string().length(0, "Phone must be only numbers. (e.g., 23456789012)"),
        z.string().regex(phonePattern, {
          message: "Phone must be only numbers. (e.g., 23456789012)",
        }),
      ])
      .optional()
      .transform((e) => (e === "" ? null : e))
      .nullish(),
    workDialCode: z.any(),
    workPhone: z
      .union([
        z.string().length(0, "Phone must be only numbers. (e.g., 23456789012)"),
        z.string().regex(phonePattern, {
          message: "Phone must be only numbers. (e.g., 23456789012)",
        }),
      ])
      .optional()
      .transform((e) => (e === "" ? null : e))
      .nullish(),
  })

